import React from "react";

export const SEND_MESSAGE_BUTTON =
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px"
         viewBox="0 0 116 95" version="1.1">
        <title>Path</title>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
            <polygon id="Path" stroke="#02818A" strokeWidth="4" fill="#02818A"
                     points="2 2 114 47.5 2 93 2 55.7738953 58 47.5 2 38.761322"/>
        </g>
    </svg>